module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 d-flex align-items-center mt-5 p-20"
  }, [_c('input', {
    class: ("img-downloader-" + (this.type)),
    attrs: {
      "type": "file",
      "multiple": "",
      "data-allowed-file-extensions": "jpg png jpeg"
    },
    on: {
      "change": function (e) { return _vm.selectImage(e, _vm.type); }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-2"
  }, [_c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "button",
      "disabled": _vm.disableAddImage
    },
    on: {
      "click": function($event) {
        _vm.addImage(_vm.type)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("button.add")) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-2"
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.vrbo.photos_format")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a115dde0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/rentals/detail/VrboConfigurationTab/ImageUploader.vue
// module id = 1424
// module chunks = 0